import { render, staticRenderFns } from "./NotificationSettingSMS.vue?vue&type=template&id=7a4de22c&scoped=true"
import script from "./NotificationSettingSMS.vue?vue&type=script&lang=js"
export * from "./NotificationSettingSMS.vue?vue&type=script&lang=js"
import style0 from "./NotificationSettingSMS.vue?vue&type=style&index=0&id=7a4de22c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a4de22c",
  null
  
)

export default component.exports